import { MAXIMUM_ROW_COUNT } from '@/components/tables/DataTable/constants';
import {
  CompactQueryData,
  usePaginatedDataTableQuery,
} from '@/components/tables/DataTable/hooks/usePaginatedDataTableQuery';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { CashflowsTable } from '@/modules/cashflows/CashflowTable/CashflowTable';
import { CashflowOrderField, OrderDirection } from '@/types/schema';

import { ClientDetailsManageIncomeExpensesPageContextProvider } from './ClientDetailsManageIncomeExpensesPage.context';
import {
  CashflowsQuery,
  CashflowsQueryVariables,
  useCashflowsQuery,
} from './graphql/ClientDetailsManageIncomeExpenses.generated';

export type CashflowsQueryData =
  | CompactQueryData<CashflowsQuery, CashflowsQueryVariables>
  | undefined;

function ClientDetailsManageIncomeExpensesPageInner({
  householdId,
}: {
  householdId: string;
}) {
  // doing the table's query at a higher level so the `refetch` function can be passed into the button
  const [paginatedTableProps, { data: cashflows, refetch }] =
    usePaginatedDataTableQuery(useCashflowsQuery, {
      pageSize: MAXIMUM_ROW_COUNT,
      variables: {
        where: {
          hasHouseholdWith: [
            {
              id: householdId,
            },
          ],
        },
        orderBy: [
          {
            field: CashflowOrderField.TransferValue,
            direction: OrderDirection.Desc,
          },
          {
            field: CashflowOrderField.StartYear,
            direction: OrderDirection.Asc,
          },
        ],
      },
    });

  return (
    <ClientDetailsManageIncomeExpensesPageContextProvider
      refetch={refetch}
      householdId={householdId}
    >
      <CashflowsTable
        tableProps={paginatedTableProps}
        cashflows={cashflows}
        refetch={refetch}
        emptyStateFill="viewport"
      />
    </ClientDetailsManageIncomeExpensesPageContextProvider>
  );
}

export function ClientDetailsManageIncomeExpensesPage() {
  const householdId = useRequiredParam('householdId');
  return (
    <ClientDetailsManageIncomeExpensesPageInner householdId={householdId} />
  );
}
